(function () {
  // Formats a price (in the shop's smallest currency unit, e.g. øre/cents) using the
  // store's own money_format from Theme Settings -> injected by layout/theme.liquid as
  // window.themeMoneyFormat. Mirrors Shopify's standard money-format placeholders so it
  // stays correct even if the store's currency or format ever changes.
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || '{{ amount }}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ' ' : thousands;
      decimal = typeof decimal === 'undefined' ? ',' : decimal;
      if (isNaN(number) || number === null) return 0;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = placeholder ? placeholder[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ' ', ',');
    }
    return placeholder ? format.replace(placeholder[0], value) : (value + ' kr');
  }

  // Mobile nav toggle
  var btn = document.getElementById('menuToggle');
  var nav = document.getElementById('primaryNav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product option selectors -> resolve matching variant, update price + add-to-cart state
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var selects = form.querySelectorAll('[data-option-selector]');
    // No option pickers on this form (single-variant product, or a compact product-card
    // quick-add) -> nothing to keep in sync. The server already rendered the right
    // variant id, price and availability, so leave them alone.
    if (!selects.length) return;

    var variantsJSON = form.getAttribute('data-variants');
    if (!variantsJSON) return;
    var variants;
    try { variants = JSON.parse(variantsJSON); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceNow = form.parentElement.querySelector("[data-price-now]")
    var priceWas = form.parentElement.querySelector("[data-price-was]")
    var addBtn = form.querySelector('[data-add-to-cart]');

    // Each [data-option-selector] is either a native <select> (legacy markup) or a
    // container holding a group of radio-button "pills" (current markup) -- read the
    // active value out of whichever shape is present.
    function selectorValue(s) {
      if (s.tagName === 'SELECT') return s.value;
      var checked = s.querySelector('input:checked');
      return checked ? checked.value : '';
    }

    function currentSelection() {
      return Array.prototype.map.call(selects, selectorValue);
    }

    function updateVariant() {
      var sel = currentSelection();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      })[0];

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = form.getAttribute('data-label-unavailable') || 'Ikke tilgjengelig'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = formatMoney(match.price);
      if (priceWas) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceWas.textContent = formatMoney(match.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = form.getAttribute('data-label-add') || 'Legg i handlekurv';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = form.getAttribute('data-label-soldout') || 'Utsolgt';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    updateVariant();
  });

  // Address form: show/hide the province/state field depending on selected country
  // (most Norwegian addresses don't need one; other countries often do).
  document.querySelectorAll('[data-address-country-select]').forEach(function (select) {
    var container = select.closest('form') ? select.closest('form').querySelector('[data-address-province-container]') : null;
    if (!container) return;
    function sync() {
      var hide = select.value === '' || select.value === 'Norway';
      container.style.display = hide ? 'none' : '';
    }
    select.addEventListener('change', sync);
    sync();
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) main.src = thumb.getAttribute('data-full');
      });
    });
  });
})();
